var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomAttributes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4908 15.9909L10.5049 15.9909M14.9764 7.99086C14.9764 9.37157 16.0957 10.4909 17.4764 10.4909C18.8572 10.4909 19.9764 9.37157 19.9764 7.99086C19.9764 6.61015 18.8572 5.49086 17.4764 5.49086C16.0957 5.49086 14.9764 6.61015 14.9764 7.99086ZM13.4977 7.99086L3.50913 7.99086L13.4977 7.99086ZM3.99084 15.9909C3.99084 17.3716 5.11013 18.4909 6.49084 18.4909C7.87156 18.4909 8.99084 17.3716 8.99084 15.9909C8.99084 14.6101 7.87156 13.4909 6.49084 13.4909C5.11013 13.4909 3.99084 14.6101 3.99084 15.9909Z",
    stroke: "#22222D",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomAttributes);
export default __webpack_public_path__ + "static/media/custom-attributes.70ab2f86.svg";
export { ForwardRef as ReactComponent };